







































































































































import type Server from '@tridoc/frontend'
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'

@Component({})
export default class TagAdder extends Vue {
  @Prop() id!: string;
  @PropSync('meta') docMeta !: tdDocMeta
  allTags: tdTag[] = []
  show = -1
  valid = true
  label = ''
  type: 'simple' | 'date' | 'decimal' = 'simple'
  value = ''
  valDate = ''
  fixed = false
  dateMenu = false

  @Watch('label')
  change (l: string) {
    const exists = this.allTags.find(t => t.label === l)
    if (exists) {
      this.fixed = true
      this.type = exists.parameter
        ? (exists.parameter.type === 'http://www.w3.org/2001/XMLSchema#decimal'
          ? 'decimal'
          : 'date')
        : 'simple'
    } else {
      this.fixed = false
    }
  }

  labelRules: FormRule[] = [
    v => !!v || 'Label is required',
    v => !(/\s|\/|\\|#|"|'|,|;|:|\?/.test(v)) || 'The label must not contain any of the following: whitespace / \\ # " \' , ; : ?',
    v => !(/^[.]{1,2}$/.test(v)) || 'The label must not equal . (single dot) or .. (double dot)',
  ]

  getType () {
    return this.type
  }

  valRules: FormRule[] = [
    v => (this.getType() === 'decimal' && !isNaN(+v) && !!v) || this.getType() !== 'decimal' || 'Must be a number',
    v => (/^\d{4}-\d{2}-\d{2}$/.test(v) && !isNaN(new Date(v).getTime())) || this.getType() !== 'date' || 'Must be a date of format YYYY-MM-DD',
  ]

  @Watch('type')
  typeChanged () {
    this.value = '';
    (this.$refs.form as any).resetValidation()
  }

  clear () {
    this.label = ''
    this.type = 'simple';
    (this.$refs.form as any).resetValidation()
  }

  async save () {
    this.valid = (this.$refs.form as any).validate()
    const cs = this.$store.getters.server.server as Server
    if (cs && this.valid) {
      await this.reloadTags()
      if ((this.docMeta.tags || []).findIndex(t => t.label === this.label) !== -1) {
        alert('Tag has already been added to the document')
        return // see also comment further below
      } else if (this.allTags.findIndex(t => t.label === this.label) === -1) {
        if (confirm('This tag doesn’t exist yet. Do you want to create it?')) {
          await cs.createTag(this.label, this.type !== 'simple' ? this.type : undefined)
            .then(r => {
              if ('error' in r) {
                console.error(r) // eslint-disable-line no-console
              }
            })
        } else {
          this.reload();
          return;
        }
      }
      cs.addTag(this.id, this.label, this.type !== 'simple' ? this.type : undefined, this.type !== 'simple' ? this.value : undefined)
        .then((r: {error?: string}) => {
          if (r.error) {
            this.$emit('error', r)
            this.reload()
            // this.clear()
          } else {
            this.$emit('tagadded')
            this.reload();
            (this.$refs.form as any).reset()
          }
        })
    }
  }

  removeTag (label: string) {
    const cs = this.$store.getters.server.server as Server
    if (cs && confirm(`Do you want to remove tag "${label}" from the Document?
This Action cannot be undone`)) {
      cs.removeTag(this.id, label).then(this.reload)
    }
  }

  reloadTags () {
    const cs = this.$store.getters.server.server as Server
    if (cs) {
      return cs.getTags()
        .then(r => {
          if (!('error' in r)) {
            this.allTags = r.filter(t => {
              return /* !!t.parameter || */ (this.docMeta.tags || []).findIndex(mt => mt.label === t.label) === -1 // while it is possible to add a paramterisable tag multiple times to a document, it's not possible to remove only selct ones of them, thus tridoc-cockpit discourages this.
            })
          }
        })
    }
  }

  reload () {
    const cs = this.$store.getters.server.server as Server
    if (cs) {
      cs.getMeta(this.id)
        .then(r => {
          if (!('error' in r)) {
            this.$emit('update:meta', { ...r, identifier: this.id })
          }
        }).then(() => {
          this.reloadTags()
        })
    }
  }

  created () {
    this.reload()
  }
}
